export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-18 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">
          平台介绍
        </h2>
        <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-2xl mx-auto">
          榴莲视频成立于2024年，是一家专注于高清影视聚合的综合性视频平台。我们致力于整合苹果视频、91视频网站、豆花视频、菠萝视频、红杏视频、青青草视频等优质影视站点的海量资源，通过先进的技术架构和智能推荐算法，为用户提供一站式的视频播放和影视观看服务。
        </p>
        <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl mx-auto">
          平台覆盖电影、电视剧、综艺、动漫、纪录片等多个品类，支持从标清到4K超清的多档画质选择。我们的内容运营团队7×24小时不间断更新，确保热门新片、热播剧集能够第一时间触达用户。未来，榴莲视频将持续拓展合作站点矩阵，不断优化高清影视观看体验，打造更完善的视频生态。
        </p>
      </div>
    </section>
  );
}